import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Theme } from "@/types";

export interface ThemeState {
    type: Theme;
}

export const getTheme = (): Theme => {
    const theme = window?.localStorage?.getItem("theme");
    if (theme === Theme.LIGHT || theme === Theme.DARK) {
        return theme;
    }
    return Theme.DARK;
};

const initialState: ThemeState = {
    type: getTheme(),
};

export const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        set: (state, action: PayloadAction<Theme>) => {
            state.type = action.payload;
        },
        toggleTheme: (state) => {
            const newTheme =
                state.type === Theme.DARK ? Theme.LIGHT : Theme.DARK;

            localStorage.setItem("theme", newTheme);

            state.type = newTheme;
        },
    },
});

export const { set, toggleTheme } = themeSlice.actions;

export default themeSlice.reducer;
